import React from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Replays a subtle fade + gentle rise entrance animation on every page
 * navigation. Keyed on `pathname` so real route changes re-trigger the
 * animation while query-string/pagination changes do not. Respects
 * `prefers-reduced-motion` via `motion-reduce:animate-none`.
 */
export function PageTransition({ children }: PageTransitionProps) {
  const { pathname } = useLocation();

  return (
    <div
      key={pathname}
      className="w-full animate-in fade-in-0 slide-in-from-bottom-2 duration-[700ms] ease-out motion-reduce:animate-none"
    >
      {children}
    </div>
  );
}
